import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { myListsEditListFormStyles } from "@insite/content-library/Widgets/MyLists/MyListsEditListForm";

myListsEditListFormStyles.cancelButton = mergeToNew(myListsEditListFormStyles.cancelButton, {
    variant: "secondary"
});